import { Component, ChangeDetectorRef, Input } from '@angular/core';
import { GridsterItem } from 'angular-gridster2';
import { WidgetsHelper } from '../widgets/widgets.helper';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'interfacebuilder-renderer',
  template: `<interface-widget-grid class="grid" [ngClass]="{ 'grid-fill': !editable}" (targetConfig)="updateConfig($event)"
  [dashboard]="dashboard" [reset]="resetConfig" [editable]="editable"></interface-widget-grid>
<interface-widget-list *ngIf="!targetConfig && editable" class="list"></interface-widget-list>
<interface-widget-configurator *ngIf="!!targetConfig && !!dashboard" [item]="targetConfig" (onSave)="saveConfig($event)"
  (onClose)="clearConfig()"></interface-widget-configurator>`,
  styles: [`:host{display:block;width:100%;height:100%;background-color:#ddd}.grid{padding:0;margin:0;display:inline-block;height:100%;width:calc(100% - 350px)}.grid-fill{width:100%}.list{float:right;width:350px;height:100%}`],
})
export class RendererComponent {
  targetConfig: GridsterItem;
  resetConfig: boolean;

  @Input() dashboard: Array<GridsterItem>;

  private _editable: boolean;
  @Input()
  set editable(editable) {
    this._editable = editable;
    this.ref.detectChanges();
  }
  get editable() {
    return this._editable;
  }

  constructor(private ref: ChangeDetectorRef) { }

  updateConfig(config) {
    this.clearConfig(false);
    this.targetConfig = config;
  }

  saveConfig(formData) {
    formData = WidgetsHelper.sanizeConfig(formData);
    const old = JSON.parse(JSON.stringify(this.dashboard));
    this.targetConfig = Object.assign(this.targetConfig, formData);
    const index = this.dashboard.indexOf(this.targetConfig);
    this.dashboard = undefined;
    old.splice(index, 1);
    old.splice(index, 0, this.targetConfig);
    this.ref.detectChanges();
    this.dashboard = old;
    this.clearConfig();
  }

  clearConfig(emitEvent = true) {
    this.targetConfig = undefined;
    if (emitEvent) {
      this.resetConfig = true;
    }
    this.ref.detectChanges();
    if (emitEvent) {
      this.resetConfig = undefined;
    }
  }
}
